import React from 'react';
import { Badge as ChakraBadgeBase } from '@chakra-ui/react';

/**
 * Chakra UI版のBadgeコンポーネント
 * 既存のTailwind版と並行して使用可能
 */
const ChakraBadge = ({
  children,
  variant = 'solid',
  colorScheme = 'brand',
  size = 'md',
  ...props
}) => {
  return (
    <ChakraBadgeBase
      variant={variant}
      colorScheme={colorScheme}
      size={size}
      {...props}
    >
      {children}
    </ChakraBadgeBase>
  );
};

export default ChakraBadge;